/* eslint-disable react/prop-types */
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import _ from 'lodash';

import Picture from './oc-picture';
// eslint-disable-next-line camelcase
import placeholder_url from '../../placeholder';

const defaults = {
  heroDesktop: placeholder_url(2680, 1090),
};

const HeroContainer = styled.div`
  align-items: flex-start;
  ${props => props.bgStyles}
  display: flex;
  flex-direction: column;
  min-height: 352px;
  position: relative;
  width: 100%;

  @media (min-width: 768px) {
    min-height: 548px;
  }

  @media (min-width: 1200px) {
    aspect-ratio: 16 / 9;
    min-height: 680px;
  }
`;

const HeroVideo = styled.video`
  height: 100%;
  left: 0;
  object-fit: cover;
  position: absolute;
  top: 0;
  width: 100%;
`;

const MainContent = styled.div`
  align-items: center;
  color: #FFFFFF;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  font-size: 30px;
  justify-content: center;
  padding: 5%;
  position: relative;
  width: 100%;
`;

const HeroTitle = styled.h1`
  color: #FFFFFF;
  font-family: 'Oswald Regular', sans-serif;
  font-size: 80px;
  font-style: normal;
  font-weight: 400;
  line-height: 85px;
  margin-bottom: 16px;
  text-shadow: 0 -1px 10px rgba(0, 0, 0, 0.4);
  text-transform: uppercase;

  @media (max-width: 1199px) {
    font-size: 54px;
    line-height: 58px;
  }

  @media (max-width: 767px) {
    font-size: 36px;
    line-height: 38px;
  }
`;

const HeroPosthead = styled.div`
  color: #FFFFFF;
  font-family: 'OC Roboto', sans-serif;
  font-size: 26px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  text-align: center;
  text-shadow: 0 -1px 10px rgba(0, 0, 0, 0.4);

  &:has(+ div) {
    margin-bottom: 64px;
  }

  @media (max-width: 1199px) {
    font-size: 20px;
    line-height: 18px;

    &:has(+ div) {
      margin-bottom: 48px;
    }
  }

  @media (max-width: 767px) {
    font-size: 14px;
    line-height: 12px;

    &:has(+ div) {
      margin-bottom: 24px;
    }
  }
`;

const HeroCTAs = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;

  .oc-cta-container:first-of-type {
    padding-top: 0;
  }
`;

const HeroTier5 = ({
  imgDesktop,
  imgTablet,
  imgMobile,
  imgAlt,
  mediaType,
  h1,
  posthead,
  ctas,
  videoWebm,
  videoMp4,
}) => {
  const processedImgDesktop = Picture.DefaultOrCrop(imgDesktop?.file, imgDesktop?.crop, defaults.heroDesktop);
  const processedImgTablet = Picture.DefaultOrCrop(
    imgTablet?.file,
    imgTablet?.crop,
    imgDesktop?.file || defaults.heroDesktop
  );
  const processedImgMobile = Picture.DefaultOrCrop(
    imgMobile?.file,
    imgMobile?.crop,
    imgDesktop?.file || defaults.heroDesktop
  );
  const imgDesktopAlt = imgDesktop && imgDesktop?.alt ? imgDesktop?.alt : imgAlt;

  const backgroundImageStyles = Picture.Background(
    processedImgMobile,
    {
      styles: css`
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
      `,
    },
    [
      {
        media: '(min-width: 768px)',
        styles: '',
        url: processedImgTablet,
      },
      {
        media: '(min-width: 1200px)',
        styles: '',
        url: processedImgDesktop,
      }
    ]
  );

  return (
    <HeroContainer
      aria-label={mediaType === 'image' ? imgDesktopAlt : null}
      bgStyles={backgroundImageStyles}
      mediaType={mediaType}
      role={mediaType === 'image' ? 'img' : null}
    >
      {mediaType === 'video' && (
        <HeroVideo playsInline muted autoPlay loop>
          <source src={videoWebm} type="video/webm" />
          <source src={videoMp4} type="video/mp4" />
        </HeroVideo>
      )}

      <MainContent>
        {h1 && <HeroTitle>{h1}</HeroTitle>}
        {posthead && <HeroPosthead>{posthead}</HeroPosthead>}
        {!_.isEmpty(ctas?.props?.ctas) && <HeroCTAs>{ctas}</HeroCTAs>}
      </MainContent>
    </HeroContainer>
  );
};

export default HeroTier5;
